import useLayoutColorTheme from './useLayoutColorTheme'

export default function useIsDarkMode() {
  const theme = useLayoutColorTheme()

  return theme === 'dark' || theme === 'darkv2'
}
